import React from 'react';
import { FadeIn } from './FadeIn';
import { X, Check } from 'lucide-react';
export function Transformation() {
  const before = ['No sabés cómo ordenar el caso desde la primera consulta.', 'Sentís que improvisás más de lo que te gustaría.', 'La familia no sostiene y no sabés cómo bajar mejor el mensaje.', 'El chico no incorpora y te faltan recursos concretos.', 'La consulta queda en palabras y el plan termina en papel.', 'Te llevás casos en la cabeza todo el día.'];
  const after = ['Entrás a la consulta con más estructura y claridad.', 'Tenés materiales listos para evaluar, intervenir y explicar.', 'Trabajás con más seguridad incluso en casos difíciles.', 'Podés mostrar, entregar y reforzar con recursos concretos.', 'Ayudás al niño a entender mejor qué alimentos forman parte de su alimentación.', 'Recuperás tiempo, orden y tranquilidad profesional.'];
  return <section className="py-10 md:py-14 px-4 bg-black" data-id="element-244">
      <div className="max-w-5xl mx-auto" data-id="element-245">
        <FadeIn className="text-center mb-16" data-id="element-246">
          <span className="text-sand text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-247">
            La transformación
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-cream" data-id="element-248">
            De consulta caótica a consulta mucho más clara
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-249">
          {/* Before Column */}
          <FadeIn delay={0.1} data-id="element-250">
            <div className="bg-black border border-cream/10 rounded-3xl p-8 md:p-10 h-full" data-id="element-251">
              <h3 className="font-display text-2xl font-bold text-cream/50 mb-8 flex items-center gap-3 border-b border-cream/10 pb-6" data-id="element-252">
                <span className="w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center text-red-400" data-id="element-253">
                  <X size={18} data-id="element-254" />
                </span>
                Hoy · Sin MegaPack
              </h3>
              <ul className="space-y-6" data-id="element-255">
                {before.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-256">
                    <X size={20} className="text-red-400 shrink-0 mt-0.5 opacity-70" data-id="element-257" />
                    <span className="text-cream/70 leading-relaxed" data-id="element-258">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* After Column */}
          <FadeIn delay={0.2} data-id="element-259">
            <div className="glow-beige-pulse bg-black rounded-3xl p-8 md:p-10 h-full relative overflow-hidden" data-id="element-260">
              <h3 className="font-display text-2xl font-bold text-cream mb-8 flex items-center gap-3 border-b border-sand/30 pb-6 relative z-10" data-id="element-261">
                <span className="w-8 h-8 rounded-full bg-sand/15 border border-sand/30 flex items-center justify-center text-sand" data-id="element-262">
                  <Check size={18} data-id="element-263" />
                </span>
                Mañana · Con MegaPack
              </h3>
              <ul className="space-y-6 relative z-10" data-id="element-264">
                {after.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-265">
                    <Check size={20} className="text-sand shrink-0 mt-0.5" data-id="element-266" />
                    <span className="text-cream/85 font-medium leading-relaxed" data-id="element-267">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}